import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth24: ToothDataEntry = {
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M28.6,80.8l-1.6-7.2v-11.1l3.4-12.6,4.3-6.5,7-4.9,15.8-9.9,16.2-7,6.7-1.6,13.5-.2,7.6,2,8.4,5,9,7.6,11.7,13.1,2.5.7,3.8,3.1,4,7,2.2,6.5v15.6l-.9,9.7-5,21-3.2,11.1-2.7,10.6-1.3,5.2s-40.3,42.6-81.6,11.9l-13.5-44.9-6.1-24.3Z',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M129.8,138.2s-28.7,41.5-81.6,11.9l-7.7-25.8h11.2s12.2-.9,12-11l-.6-52.6h48.9l1.4,51.5s.6,9.8,16.2,9.8h4.1l-4,16.2Z',
			},
			[ToothSurface.PalatalCusp]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '141.2 60.5 112 60.6 63.1 60.6 27.7 60.6 29.2 53.2 33 45.5 40.7 39.2 52.3 31.4 66.1 24.3 80.1 20.1 94.2 20.1 103.1 22.8 110.3 27 130.2 47.4 134.8 49.4 138.7 53.4 141.2 57.3 141.2 59.7 141.2 60.5',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M63.7,113.2l-.6-52.6V25.6l-19.5,11.6-9.3,6.3-4.8,7.3-2.3,12.9v11.6l13.4,48.9s23.2,3.9,23.2-11Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M112,60.6l1.4,51.5s1.5,11.9,20.3,9.8l4.6-18.2,4.5-19.5.5-7.2-.5-10.9-.9-7.2-2.7-5.4-3.4-4.5-3.6-2-2.9-1.1-6.1-7.2-7.3-7.2-4.8-3.8.9,32.6Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M28.6,80.8l-1.6-7.2v-11.1l3.4-12.6,4.3-6.5,7-4.9,15.8-9.9,16.2-7,6.7-1.6,13.5-.2,7.6,2,8.4,5,9,7.6,11.7,13.1,2.5.7,3.8,3.1,4,7,2.2,6.5v15.6l-.9,9.7-5,21-3.2,11.1-2.7,10.6-1.3,5.2s-40.3,42.6-81.6,11.9l-13.5-44.9-6.1-24.3Z',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M129.8,138.2l-2.3,13.9s-22.3,26.3-78.8,7.9l-.5-10s47.8,27.4,81.6-11.9Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'30.9 88.6 42.5 106.2 48.3 81.6 56.1 111.5 66.1 80.8 75.4 111.5 85.8 81.1 95.3 111.5 105.7 79.1 114.1 109.9 125.4 79.1 128.8 105 141.2 86.5',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'92.8 160.4 81.2 168.4 94.4 178.1 82.5 186.5 94.9 195.3 83.6 203.1 94.7 211.1 83.6 218.7 96.4 227.8 85.7 235.2 95.9 242.4 85.2 249.8 97.6 253.7 86.2 262.9 101.4 268.6 89.8 280.3 103.8 283.2 92 295.7 107.1 301.2 93.5 310.8 108.6 317.4 95.3 328.5 111.2 333.3 97.9 343.6 111.9 351.3 104.5 363.1 118.1 370.5 109.7 382.2 122.6 395.5',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'60.2 267.4 64.2 280.8 68.9 266.7 74 279.5 79.9 267.8 87 281.6 93.5 265 101.3 280.8 108.9 265 115.4 279.5 121.9 265.4',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '42.5 59.1 49.1 51.8 55.5 47 62.6 43 69.4 41 75.8 39.8 88.1 39.6 94.1 40.8 100.7 42.4 110.2 46.2 116 50 124.4 57.7 128.1 63.1 132.5 71.5 134.3 76.9 136.9 89.2 137.3 95.6 137.1 105.9 136.3 114.5 132.7 126.2 125.8 140.2 120.2 147.5 113.8 152.3 103.3 159.9 95.1 162.1 90.9 162.9 84.9 163.3 80.8 163.1 75 162.5 66.2 159.1 59.9 155.1 51.9 147.5 43.5 138.8 37.8 129.2 33.6 118.7 31.8 107.7 31.4 99 30.8 86.8 32.8 78.2 37.6 67.9 41.1 60.5 42.5 59.1',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M35.7,123.7l-3.9-15.7-.8-6.9.3-14.7,2.8-10.3,2.6-5.9s51.8,36.5-1,53.6Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M132.8,72.3l2.9,9,1.5,9,.2,16.9-1.1,8.8-3.6,11.8s-50.8-17.2.2-55.5Z',
			},
			[ToothSurface.BuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M132.8,72.3s-16.6,19.6-29.6,19.4-6.7-8.2-18.9-8.3-6.6,8.9-18.2,8.9-29.5-22-29.5-22l8.7-14.2,8.5-7.9,8.2-4.6,7.8-2.3,7.8-1.1,13.3.3,10.3,2.1,10.1,4.5,7.2,5.3,6.8,7.2,4.8,7.1,2.7,5.8Z',
			},
			[ToothSurface.PalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M132.6,127.8s-17.1-17.1-29.9-16.9-7.5,7-18.1,7.2-6.8-8.3-18.5-8.2-30.6,13.8-30.6,13.8l3.4,8.4,6.7,9.8,8.2,8.6,7.9,6.3,5.7,3.1,9,3.7,16.3.3,9.6-3.1,9.6-6,8.8-8.2,7.1-9.3,4.7-9.5Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M53.5,86.5s6.6,5.6,12.7,5.6,6.4-8.9,18.2-8.9,7.6,8.3,18.9,8.3,14.9-5.9,14.9-5.9c0,0-12.8,13.5-5,28,0,0-6.5-2.8-10.3-2.8-11,0-5,7.2-18.1,7.2s-6.2-8.2-18.5-8.2-10.8,2.4-10.8,2.4c0,0,9.3-9.8-2-25.8Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M36.6,70.1l8.7-14.2,8.5-7.9,8.2-4.6,7.8-2.3,7.8-1.1,13.3.3,10.3,2.1,10.1,4.5,7.2,5.3,6.8,7.2,4.8,7.1,2.7,5.8s-48.9-36.4-96.2-2.1Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M132.6,127.8l-4.7,9.5-7.1,9.3-8.8,8.2-9.6,6-9.6,3.1-16.3-.3-9-3.7-5.7-3.1-7.9-6.3-8.2-8.6-6.7-9.8-3.4-8.4s41.3,47.2,97,4.1Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'31 93.8 44.4 106.6 47.7 85.7 58 110.8 66.1 85.7 75.8 111.9 84.9 87.2 94.5 111.9 103.4 86.9 112.7 111.9 120 87.5 125.4 107.5 136.3 93.2',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M124.3,372.5c.5.1,13.2,38.4,13.2,38.4l1.3,9.3v16.7l-.8,6.5-8.7,18.1-12.4,16.7-10.1,8.5-10.1,3.6-14.9.2-11.9-2.8-14.2-7.7-11-11.8-7.8-14.1-2.8-12.7-.7-8.7.8-10,3.1-17.3,4.6-18,4.7-16.7s36.6-9.4,77.6,1.6Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M39.7,398.9l7.2-28s33-9.4,77.5,1.4l8.9,26.2-16.7-.2s-10.2-.6-10.4,11.4l-.2,27.1-36-.2.2-26.3s1.1-12.2-11.6-11.4h-18.9Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M66.8,485.5l-14.3-8.5-8.2-9.3-5.4-9.4-3.6-9.4-1.6-10.5-.2-11.4,1.5-10.4,2.9-10.7,2-6.8h18.9s11.9-1.6,11.6,11.4l-.2,26.3v50.1l-3.2-1.3Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M133.3,398.5l4,14.3,1.2,5.7.2,18.6-1.9,8.1-4.3,9.6-7.4,12.2-7.4,10.2-10.8,8.4-1.9.8,1.2-49.5.2-27.1s-.4-11.6,10.4-11.4l16.7.2Z',
			},
			[ToothSurface.BuccalCusp]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '138.8 437.1 106.1 436.8 70.1 436.7 34.3 436.8 34.4 445.2 38.2 457.7 44.6 468.7 51.8 476.7 62.5 484 71.6 488.3 81.7 491 94.5 490.7 103.6 488.1 112 482.8 119.3 475.3 126.6 465.7 132 456.3 136.4 446.4 138.4 440.4 138.8 437.1',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M124.3,372.5c.5.1,13.2,38.4,13.2,38.4l1.3,9.3v16.7l-.8,6.5-8.7,18.1-12.4,16.7-10.1,8.5-10.1,3.6-14.9.2-11.9-2.8-14.2-7.7-11-11.8-7.8-14.1-2.8-12.7-.7-8.7.8-10,3.1-17.3,4.6-18,4.7-16.7s36.6-9.4,77.6,1.6Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M46.6,370.9s35.7-9.3,77.6,1.6l-1-5.6s-44-14.3-75.7-1.1l-.9,5.1Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'140.6 434.4 126.3 419.4 121.1 442.1 113.9 414.4 104.7 442.9 96.1 414.4 86.5 442.6 77.7 414.4 68.1 444.4 60.2 415.9 49.9 444.4 46.8 420.5 35.6 435.9',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'84.9 379.5 99.6 370.3 82.8 359.2 97.9 349.5 82.3 339.3 96.5 330.5 82.5 321.2 96.5 312.5 80.2 302.1 93.9 293.5 81 285.3 94.5 276.7 80.6 267.5 94.8 258.5 81.5 249.8 95.9 241 83.6 232.9 97.7 224 82.8 214.2 99.2 203.9 84.7 194.4 100.8 184.2 86.2 174.6 102 164.6 84.9 153.4 99.6 144.1 86.9 130.8 101.7 120.3 97.9 93.3',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'110.5 243.2 107.2 228.1 99.7 243.4 94.2 228.6 88.9 243.5 81.4 227.9 73.8 244 67.5 227.9 62 244.4 55.4 229.4 50.6 244.6',
			],
		},
	},
};
